import {onlineContractService} from "../../common/api.service";
import { contractStatus } from '@/constants/onlineContract';

const initialStates = {
    form_data: {},
    contracts: {},
    pending_count: 0,
    contract_status: 'loading',
    contract_statistics: '',
    contract_statistics_status: 'loading'
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    setFormData(state, form_data) {
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key) {
            state.form_data[key] = ''
        });
    },
    loadingContractStatus(state) {
        state.contract_status = 'loading'
    },
    contractStatusSuccess(state , contract) {
        state.contracts = contract
        state.contract_status = 'success'
    },
    pendingCount(state, count){
        state.pending_count = count
    },
    loadingContractStatisticsStatus(state) {
        state.contract_status = 'loading'
    },
    contractStatisticsStatusSuccess(state , contract_statistics) {
        state.contract_statistics = contract_statistics
        state.contract_statistics_status = 'success'
    },
}

const getters = {
    form_data: ({form_data}) => form_data,
    contracts: ({contracts}) => contracts,
    pending_count: ({pending_count}) => pending_count,
    contract_status: ({contract_status}) => contract_status,
    contract_statistics: ({contract_statistics}) => contract_statistics,
    contract_statistics_status: ({contract_statistics_status}) => contract_statistics_status,
}

const actions = {
    getUserContracts({commit}) {
        commit('loadingContractStatus')
        return onlineContractService.getUserContracts().then(response => {
            commit('contractStatusSuccess', response.data.data.data)
            let pendingCount = response.data.data.data.filter(
                (item) => item.status === contractStatus.PENDING
            ).length
            commit('pendingCount', pendingCount)
        })
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}